import { render } from "./ApplicantWarningMessage.vue?vue&type=template&id=5fa66e5a"
const script = {}

import exportComponent from "/home/runner/work/rentapplication-frontend-vue/rentapplication-frontend-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__